import { FC } from "react";
import {
    Box,
  Dialog,
  DialogActions,
  useMediaQuery,
} from "@mui/material";

import "./style.css";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { ConteudoModalInstalacao } from "./ConteudoModalInstalacao";
import theme from "src/theme/light";
import { ConteudoModalInstalacaoMobile } from "./ConteudoModalInstalacaoMobile";

export interface ModalInstalacaoProps {
    isOpened: boolean;
    close: () => void;
    modulosInversoresState: any[];
    componentesState: any[];
}

const ModalInstalacao: FC<ModalInstalacaoProps> = ({ isOpened, close, componentesState, modulosInversoresState }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const FooterBottom = isMobile ? Box : DialogActions;

    return (
        <>
            <div>
                <Dialog
                    open={isOpened}
                    onClose={close}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='md'
                    className="modal-instalacao"
                >
                    { isMobile 
                        ? <ConteudoModalInstalacaoMobile componentesState={componentesState} modulosInversoresState={modulosInversoresState} />
                        : <ConteudoModalInstalacao componentesState={componentesState} modulosInversoresState={modulosInversoresState} />
                    }

                    <FooterBottom className="fotter-modal-instalacao">
                        <FlatButton
                            color="primary"
                            variant="contained"
                            disableElevation
                            text="Fechar"
                            onClick={close}
                            fullWidth={isMobile}
                        />
                    </FooterBottom>
                </Dialog>
            </div>
        </>
    );
};

export { ModalInstalacao };
